import * as R from 'ramda'

const tags = ['new', 'exclusive', 'featured', 'hot', 'popular', 'sagaLikes']

// TODO no need to check for brand after brands split
export const tagPrefix = R.curry((isCasitabi, t) =>
  R.concat(isCasitabi && R.includes(t, tags) ? 'ct_' : '', t)
)
